export const PARTNER_STORAGE_KEYS = {
  PROJECTS: 'partnerPortal:projects',
  ACTIVITIES: 'partnerPortal:activities',
  ROLE_OVERRIDE: 'partnerPortal:roleOverride',
  SEEDED: 'partnerPortal:seeded',
  SUBMIT_PROJECT_DRAFT: 'partnerPortal:submitProjectDraft',
  LEADERSHIP_DARK_MODE: 'partnerPortal:leadershipDarkMode',
};
